{
  "confluence-inline-reactions-mcu-nudge.description.many-reactions": [
    {
      "type": 1,
      "value": "user1"
    },
    {
      "type": 0,
      "value": ", "
    },
    {
      "type": 1,
      "value": "user2"
    },
    {
      "type": 0,
      "value": " and "
    },
    {
      "type": 1,
      "value": "count"
    },
    {
      "type": 0,
      "value": " other"
    },
    {
      "offset": 0,
      "options": {
        "one": {
          "value": [
          ]
        },
        "other": {
          "value": [
            {
              "type": 0,
              "value": "s"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "count"
    },
    {
      "type": 0,
      "value": " reacted to this page"
    }
  ],
  "confluence-inline-reactions-mcu-nudge.description.no-reactions": [
    {
      "type": 0,
      "value": "Be the first one to react"
    }
  ],
  "confluence-inline-reactions-mcu-nudge.description.one-reaction": [
    {
      "type": 1,
      "value": "user"
    },
    {
      "type": 0,
      "value": " reacted to this page"
    }
  ],
  "confluence-inline-reactions-mcu-nudge.description.two-reactions": [
    {
      "type": 1,
      "value": "user1"
    },
    {
      "type": 0,
      "value": " and "
    },
    {
      "type": 1,
      "value": "user2"
    },
    {
      "type": 0,
      "value": " reacted to this page"
    }
  ],
  "confluence-inline-reactions-mcu-nudge.title": [
    {
      "type": 0,
      "value": "Love this page? Let "
    },
    {
      "type": 1,
      "value": "authorName"
    },
    {
      "type": 0,
      "value": " know"
    }
  ],
  "post-office.confluence-resurrected-user-welcome-back.body": [
    {
      "type": 0,
      "value": "Catch up on the top discussions and highlights from your team."
    }
  ],
  "post-office.confluence-resurrected-user-welcome-back.close": [
    {
      "type": 0,
      "value": "Close"
    }
  ],
  "post-office.confluence-resurrected-user-welcome-back.cta": [
    {
      "type": 0,
      "value": "See what's popular"
    }
  ],
  "post-office.confluence-resurrected-user-welcome-back.image-alt": [
    {
      "type": 0,
      "value": "Two hearts overlapped with each other"
    }
  ],
  "post-office.confluence-resurrected-user-welcome-back.next-best-action.header": [
    {
      "type": 0,
      "value": "Welcome back"
    }
  ]
}